import "@abgov/web-components/index.css";
import "./application-generator.css";

import { Provider } from "react-redux";
import { GoabPageBlock, GoabSpacer } from "@abgov/react-components";

import { GenerationForm } from "./GenerationForm";
import { store } from "./store";
import { useGenerationSessionInitialization } from "./GenerationForm/hooks";
import { GenerationFormProvider } from "./GenerationForm/context";

export function ApplicationGenerator() {
  return (
    <Provider store={store}>
      <GenerationFormProvider>
        <GeneratorPage />
      </GenerationFormProvider>
    </Provider>
  );
}

function GeneratorPage() {
  useGenerationSessionInitialization();

  return (
    <GoabPageBlock width={"904px"}>
      <GoabSpacer vSpacing="l"></GoabSpacer>
      <h2>Generate Test Data</h2>
      <GoabSpacer vSpacing="l"></GoabSpacer>
      <GenerationForm />
    </GoabPageBlock>
  );
}
